export default __webpack_public_path__ + "static/media/el4.94ff43ff.svg";